import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Avatar,
  Card,
  Grid,
  CardContent,
  Typography,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  statsItem: {
    alignItems: 'center',
    display: 'flex'
  },
  statsIcon: {
    marginRight: theme.spacing(1)
  },
  avatar: {
    width: 'auto',
    height: 'auto'
  }
}));

const ProductCardPreview = ({
  className, product, ...rest
}) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid container spacing={1}>
          <Grid container item xs={3} direction="column" justify="center" alignItems="center">
            <Avatar
              className={classes.avatar}
              alt="product"
              src={product?.primary_image}
              variant="square"
            />
          </Grid>
          <Grid item xs={9}>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="h4"
            >
              {product?.name}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              variant="body1"
            >
              {product?.description}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              variant="body1"
            >
              {product?.price > 0 ? `COP $${product?.price}` : ''}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

ProductCardPreview.propTypes = {
  className: PropTypes.string,
  product: PropTypes.object,
};

ProductCardPreview.defaultProps = {
  className: '',
  product: {},
};

export default ProductCardPreview;
